import React, {useMemo, useState} from 'react';
import {
    AuthorizationAllServiceTypeWithDefault,
    AuthorizationColumn,
    AuthorizationInfo,
    AuthorizationRecordType,
    AuthorizationRecordTypeMap, AuthorizationRecordTypeValueToName,
    AuthorizationStatusMapWithDefault,
    AuthorizationTypeMap,
    CLIENT_PROFILE_AUTHORIZATIONS_PATH,
    ClientInfo,
    clientReportTypeByAuthRecordType, DiagnosticEvaluationType,
    FunderAuthorizationRecordTypeMap,
    FunderAuthorizationSpecialityMap,
    InOfferedAuthorizationAllServiceType,
} from "./domain";
import {initState, parentCaseAuthorizationReducer} from "./parentCaseAuthorizationReducer";
import {FatOutlineButton} from "../../common/component/FatOutlineButton";
import {SimpleDropdown, ErrorDisplay} from "common";
import {NavigationSearchBar} from "../../placement/components/NavigationSearchBar";
import {ClientProfileAuthorizationTable} from "./ClientProfileAuthorizationTable";
import {ClientProfileAuthorizationModal} from "./ClientProfileAuthorizationModal";
import {ClientReportModal} from "./ClientReportModal";
import {BehaviorSubject} from "rxjs";
import {ClientReportViewModal} from "./ClientReportViewModal";
import {gql, useQuery} from "@apollo/client";
import {RelayConnection} from "../../common";
import {RelayPagination, useRelayPagination} from "../pagination";
import {Pane} from "evergreen-ui";
import {useSearchParam} from "../../common/hook";
import {useLocation} from "react-router";
import {AuthReportModals} from "./client-profile-authorization/AuthReportModals";

export const AuthorizationListColumn: Readonly<AuthorizationColumn[]> = [
    {name: 'Authorization Number', attr: 'bhpnAuthNumber', span: 2},
    {name: 'Service Type', attr: 'allServiceType', span: 2},
    {name: 'Status', attr: 'status', span: 1},
    {name: 'Start Date', attr: 'startDate', span: 2},
    {name: 'End Date', attr: 'endDate', span: 2},
    {name: 'Report Due Date', attr: 'reportDueDate', span: 2},
    {name: 'Type', attr: 'recordType', span: 2},
    {name: 'Report Submitted Date', attr: 'latestSubmittedClientReport.submittedAt', span: 2},
    {name: 'Latest Report Status', attr: 'latestSubmittedClientReport.reportStatus', span: 2},
]

export const AUTHORIZATION_LIST_QUERY = gql`
query authorizationsQuery($first: Int = 20, $after: String, $clientGuid: String, $params: AuthorizationQueryParamsInput!, $search: String, $authorizationGuid: String) {
    authorization(
        authorizationGuid: $authorizationGuid
    ) {
        guid
        sfId
       
        status 
        closedReason
        bhpnAuthNumber
        diagnosis
        serviceLine
        funderServiceType
        reportDueDate
        assessmentCode
        assessmentType
        recordType
        numOfTier
        startDate
        endDate

        careMediatedMidMinHours
        careMediatedMidHours
        
        careMediatedHighMinHours
        careMediatedHighHours
        
        practDirectBeneficialHours
        practDirectOptimalHours
        
        practMidBeneficialHours
        practMidOptimalHours
        
        practHighBeneficialHours
        practHighOptimalHours
        
        practGroupBeneficialHours
        practGroupOptimalHours
        
        allServiceType

        isDraft1
        status1
        serviceType1
        startDate1
        endDate1
        directCareBeneficialHour1
        midLevelBeneficialHour1
        highLevelBeneficialHour1
        groupCareBeneficialHour1
        directCareHour1
        midLevelHour1
        highLevelHour1
        groupCareHour1
        directCareCode1
        midLevelCode1
        highLevelCode1
        groupCareCode1

        status2
        isDraft2
        serviceType2
        startDate2
        endDate2
        directCareBeneficialHour2
        midLevelBeneficialHour2
        highLevelBeneficialHour2
        groupCareBeneficialHour2
        directCareHour2
        midLevelHour2
        highLevelHour2
        groupCareHour2
        directCareCode2
        midLevelCode2
        highLevelCode2
        groupCareCode2

        status3
        isDraft3
        serviceType3
        startDate3
        endDate3
        directCareBeneficialHour3
        midLevelBeneficialHour3
        highLevelBeneficialHour3
        groupCareBeneficialHour3
        directCareHour3
        midLevelHour3
        highLevelHour3
        groupCareHour3
        directCareCode3
        midLevelCode3
        highLevelCode3
        groupCareCode3

        status4
        isDraft4
        serviceType4
        startDate4
        endDate4
        directCareBeneficialHour4
        midLevelBeneficialHour4
        highLevelBeneficialHour4
        groupCareBeneficialHour4
        directCareHour4
        midLevelHour4
        highLevelHour4
        groupCareHour4
        directCareCode4
        midLevelCode4
        highLevelCode4
        groupCareCode4

        status5
        isDraft5
        serviceType5
        startDate5
        endDate5
        directCareBeneficialHour5
        midLevelBeneficialHour5
        highLevelBeneficialHour5
        groupCareBeneficialHour5
        directCareHour5
        midLevelHour5
        highLevelHour5
        groupCareHour5
        directCareCode5
        midLevelCode5
        highLevelCode5
        groupCareCode5

        status6
        isDraft6
        serviceType6
        startDate6
        endDate6
        directCareBeneficialHour6
        midLevelBeneficialHour6
        highLevelBeneficialHour6
        groupCareBeneficialHour6
        directCareHour6
        midLevelHour6
        highLevelHour6
        groupCareHour6
        directCareCode6
        midLevelCode6
        highLevelCode6
        groupCareCode6
        
        latestSubmittedClientReport {
            guid
            sfOperationCaseNumber
            sfCloseReason
            authorizedDate
            reportStatus
            reportType
            sfCloseDate
        }
        latestSubmittedClientReportByReportType {
            guid
            reportType
            authorizedDate
            reportStatus
            sfOperationCaseNumber
            submittedAt
            sfCloseReason
            sfCloseDate
        }

        pendingAuthorizationsByClient {
            guid
            sfId
            bhpnAuthNumber
            startDate
            endDate
        }
        draftAuthFromApprovedReportByClient {
            guid
            sfId
            bhpnAuthNumber
            startDate
            endDate
        }
    }
    authorizationsQuery(
        first: $first
        after: $after
        clientGuid: $clientGuid
        params: $params
        search: $search
    ) {
        edges {
            cursor
            node {
                guid
                sfId
               
                status 
                closedReason
                bhpnAuthNumber
                diagnosis
                serviceLine
                funderServiceType
                reportDueDate
                assessmentCode
                assessmentType
                recordType
                numOfTier
                startDate
                endDate

                careMediatedMidMinHours
                careMediatedMidHours
                
                careMediatedHighMinHours
                careMediatedHighHours
                
                practDirectBeneficialHours
                practDirectOptimalHours
                
                practMidBeneficialHours
                practMidOptimalHours
                
                practHighBeneficialHours
                practHighOptimalHours
                
                practGroupBeneficialHours
                practGroupOptimalHours
                
                allServiceType

                isDraft1
                status1
                serviceType1
                startDate1
                endDate1
                directCareBeneficialHour1
                midLevelBeneficialHour1
                highLevelBeneficialHour1
                groupCareBeneficialHour1
                directCareHour1
                midLevelHour1
                highLevelHour1
                groupCareHour1
                directCareCode1
                midLevelCode1
                highLevelCode1
                groupCareCode1

                status2
                isDraft2
                serviceType2
                startDate2
                endDate2
                directCareBeneficialHour2
                midLevelBeneficialHour2
                highLevelBeneficialHour2
                groupCareBeneficialHour2
                directCareHour2
                midLevelHour2
                highLevelHour2
                groupCareHour2
                directCareCode2
                midLevelCode2
                highLevelCode2
                groupCareCode2

                status3
                isDraft3
                serviceType3
                startDate3
                endDate3
                directCareBeneficialHour3
                midLevelBeneficialHour3
                highLevelBeneficialHour3
                groupCareBeneficialHour3
                directCareHour3
                midLevelHour3
                highLevelHour3
                groupCareHour3
                directCareCode3
                midLevelCode3
                highLevelCode3
                groupCareCode3

                status4
                isDraft4
                serviceType4
                startDate4
                endDate4
                directCareBeneficialHour4
                midLevelBeneficialHour4
                highLevelBeneficialHour4
                groupCareBeneficialHour4
                directCareHour4
                midLevelHour4
                highLevelHour4
                groupCareHour4
                directCareCode4
                midLevelCode4
                highLevelCode4
                groupCareCode4

                status5
                isDraft5
                serviceType5
                startDate5
                endDate5
                directCareBeneficialHour5
                midLevelBeneficialHour5
                highLevelBeneficialHour5
                groupCareBeneficialHour5
                directCareHour5
                midLevelHour5
                highLevelHour5
                groupCareHour5
                directCareCode5
                midLevelCode5
                highLevelCode5
                groupCareCode5

                status6
                isDraft6
                serviceType6
                startDate6
                endDate6
                directCareBeneficialHour6
                midLevelBeneficialHour6
                highLevelBeneficialHour6
                groupCareBeneficialHour6
                directCareHour6
                midLevelHour6
                highLevelHour6
                groupCareHour6
                directCareCode6
                midLevelCode6
                highLevelCode6
                groupCareCode6
                
                funderAuthorizationRecordType
                funderAuthSpeciality
        
                latestSubmittedClientReport {
                    guid
                    sfOperationCaseNumber
                    sfCloseReason
                    authorizedDate
                    reportStatus
                    reportType
                    submittedAt
                    sfCloseDate
                }

                latestSubmittedClientReportByReportType {
                    guid
                    reportType
                    authorizedDate
                    reportStatus
                    sfOperationCaseNumber
                    submittedAt
                    sfCloseReason
                    sfCloseDate
                }
                pendingAuthorizationsByClient {
                    guid
                    sfId
                    bhpnAuthNumber
                    startDate
                    endDate
                }
                draftAuthFromApprovedReportByClient {
                    guid
                    sfId
                    bhpnAuthNumber
                    startDate
                    endDate
                }
            }
        }
        totalElements
        pageInfo {
            hasPreviousPage
            endCursor
            hasNextPage
            startCursor
        }
    }
}
`

export type AuthorizationListQueryResponse = RelayConnection<AuthorizationInfo> & { totalElements: number };

export type AuthorizationListPageParams = {
    clientGuid: string;
    clientInfo: ClientInfo;
}

export function ClientProfileAuthorizationPage({clientGuid, clientInfo}: AuthorizationListPageParams) {
    const [submitting$] = useState(new BehaviorSubject<boolean>(false));
    const authorizationGuid = useSearchParam().get('authorizationGuid');
    const selectedTab = useSearchParam().get('tab');
    const location = useLocation();
    const initAuthReportModalState  = {
        showStaffingPlan$: useMemo(() => new BehaviorSubject(false), []),
        showConsultWithCCM$: useMemo(() => new BehaviorSubject(false), []),
        showTreatmentHold$: useMemo(() => new BehaviorSubject(false), []),
        showAddendum$: useMemo(() => new BehaviorSubject(false), []),
        showNoContact$: useMemo(() => new BehaviorSubject(false), []),
        showAuthReviewNeeded$: useMemo(() => new BehaviorSubject(false), []),
        showClientReturnTransferRequest$: useMemo(() => new BehaviorSubject(false), []),
        showAnticipatedDischargeDateUpdate$: useMemo(() => new BehaviorSubject(false), []),
        showMissingDocumentation$: useMemo(() => new BehaviorSubject(false), []),
        showClientFamilyConcern$: useMemo(() => new BehaviorSubject(false), []),
        showInsuranceNotification$: useMemo(() => new BehaviorSubject(false), []),
        showReportStatusInquiry$: useMemo(() => new BehaviorSubject(false), []),
    };

    const [{
        selectedAuthorizationGuid,
        showModal,
        showNewReportModal,
        showViewReportModal,
        selectedReport,
        pagination,
        serviceTypeFilter,
        authTypeFilter,
        statusFilter,
        searchFilter,
        authModalTabIndex,
    }, dispatch] = React.useReducer(parentCaseAuthorizationReducer, initState(authorizationGuid ?? null, selectedTab ?? null));

    const {
        loading,
        data,
        error,
        refetch
    } = useQuery<{
        authorizationsQuery: AuthorizationListQueryResponse,
        authorization: AuthorizationInfo
    }, {}>(AUTHORIZATION_LIST_QUERY, {
        skip: !location.pathname.includes(CLIENT_PROFILE_AUTHORIZATIONS_PATH),
        variables: {
            clientGuid: clientGuid,
            params: toGraphQlParams(serviceTypeFilter, authTypeFilter, statusFilter),
            search: searchFilter === "" ? null : searchFilter,
            authorizationGuid: authorizationGuid,
            ...pagination.toGraphQlParams()
        }
    })
    const totalAuthorizations = data?.authorizationsQuery?.totalElements ?? 0;
    const {onPaginationClick} = useRelayPagination(dispatch, totalAuthorizations);
    const selectedAuth = data?.authorizationsQuery.edges
        .map((edge) => edge.node)
        .find((auth) => auth.guid === selectedAuthorizationGuid) || data?.authorization;

    if (error) {
        return <ErrorDisplay error={error} title="Error loading authorizations" />;
    }

    return (
        <div className="h-full relative">
            <div className="h-full p-5 bg-white shadow-md flex flex-col">
                <div className="flex-1 min-h-0 flex flex-col w-full relative">
                    <div className="flex justify-between">
                        <div className="flex text-atlantis-200 items-center">
                            <div className="items-end">
                                <SimpleDropdown
                                    options={InOfferedAuthorizationAllServiceType}
                                    selected={serviceTypeFilter}
                                    minWidth={"7rem"}
                                    textColor={"atlantis-200"}
                                    setSelected={(selected) => dispatch({
                                        type: 'SET_SERVICE_TYPE_FILTER',
                                        serviceType: selected
                                    })}/>
                            </div>
                            <div className="pl-2">
                                <SimpleDropdown
                                    options={AuthorizationStatusMapWithDefault}
                                    selected={statusFilter}
                                    minWidth={"2rem"}
                                    textColor={"atlantis-200"}
                                    setSelected={(selected) => dispatch({
                                        type: 'SET_STATUS_FILTER',
                                        status: selected
                                    })}/>
                            </div>
                            <div className="pl-2">
                                <SimpleDropdown
                                    options={AuthorizationTypeMap}
                                    selected={authTypeFilter}
                                    minWidth={"2rem"}
                                    textColor={"atlantis-200"}
                                    setSelected={(selected) => dispatch({
                                        type: 'SET_AUTH_TYPE_FILTER',
                                        authType: selected
                                    })}/>
                            </div>
                        </div>
                        <NavigationSearchBar placeholder={"Search by auth number or id..."}
                                             searchQuery={searchFilter}
                                             setSearchQuery={(search) => dispatch({
                                                 type: 'SET_SEARCH',
                                                 search: search
                                             })}/>
                    </div>
                    <Pane display='flex' justifyContent='flex-end' padding={20}>
                        <RelayPagination pageInfo={data?.authorizationsQuery.pageInfo} count={totalAuthorizations}
                                         onClick={onPaginationClick}/>
                    </Pane>
                    <ClientProfileAuthorizationTable selectedAuthorizationGuid={selectedAuthorizationGuid}
                                                     loading={loading}
                                                     authorizationListQueryResponse={data?.authorizationsQuery}
                                                     dispatch={dispatch}/>
                </div>
                {
                    selectedAuthorizationGuid != null &&
                    <div className='absolute flex' style={{width: 300, bottom: 20, right: 20}}>
                        <FatOutlineButton color={'black'}
                                          text={'Unselect'}
                                          onClick={() => dispatch({
                                              type: 'SET_SELECTED',
                                              selectedAuthorizationGuid: null
                                          })}/>
                        <div style={{width: 10}}/>
                        <FatOutlineButton color={'green'} text={"View Detail"}
                                          onClick={() => dispatch({type: 'SHOW_MODAL'})}
                        />
                    </div>
                }
            </div>
            <ClientProfileAuthorizationModal
                showModal={showModal}
                dispatch={dispatch}
                authModalTabIndex={authModalTabIndex}
                submitting$={submitting$}
                clientGuid={clientGuid}
                authorizationGuid={selectedAuthorizationGuid}
                authClientReportModalState={initAuthReportModalState}
                clientInfo={clientInfo}
            />
            <ClientReportViewModal showModal={showViewReportModal}
                                   readonly
                                   hideModalFunc={() => dispatch({type: 'HIDE_VIEW_REPORT_MODAL'})}
                                   afterRemovalFunc={() => {
                                        submitting$.next(true);
                                        dispatch({type: 'HIDE_VIEW_REPORT_MODAL'});
                                        refetch();
                                   }}
                                   report={selectedReport}/>
            <ClientReportModal showModal={showNewReportModal}
                               hideModalFunc={() => dispatch({type: 'HIDE_NEW_REPORT_MODAL'})}
                               clientGuid={clientGuid}
                               recordTypeOption={clientReportTypeByAuthRecordType(selectedAuth)}
                               defaultAuth={selectedAuth ?? undefined}
                               refetch={
                                   () => {
                                       dispatch({type: 'SET_AUTH_MODAL_TAB_INDEX', index: 1});
                                       submitting$.next(true);
                                       refetch();
                                   }
                               }
            />
            {
                selectedAuth != null &&
                <AuthReportModals
                    authorization={selectedAuth}
                    clientGuid={clientGuid}
                    authState={initAuthReportModalState}
                    refetch={() => {
                        submitting$.next(true);
                        refetch();
                    }}
                />
            }
        </div>
    );
}

const toGraphQlParams = (
    serviceTypeFilter: string,
    authTypeFilter: string,
    statusFilter: string,
) => {
    let faRecordType = authTypeFilter === "" || !FunderAuthorizationRecordTypeMap.has(authTypeFilter) ? null : authTypeFilter;
    let recordType = authTypeFilter === "" || !AuthorizationRecordTypeMap.has(authTypeFilter) ? null : authTypeFilter;
    let serviceType = serviceTypeFilter === "" ? null : serviceTypeFilter
    let funderAuthSpeciality: string | null = null;

    if (serviceTypeFilter && FunderAuthorizationSpecialityMap.has(serviceTypeFilter)) {
        funderAuthSpeciality = FunderAuthorizationSpecialityMap.get(serviceTypeFilter) ?? null;
        serviceType = null;
    }

    if (serviceTypeFilter && AuthorizationAllServiceTypeWithDefault.get(serviceTypeFilter) === DiagnosticEvaluationType.Diagnostic_Evaluation) {
        recordType = AuthorizationRecordTypeValueToName.get(AuthorizationRecordType.Diagnostic_Evaluation_Authorization) ?? null;
        serviceType = null;
    }

    return (
        {
            recordType: recordType,
            faRecordType: faRecordType,
            status: statusFilter === "" ? null : statusFilter,
            serviceTypes: serviceType ? [serviceType] : null,
            funderAuthSpeciality: funderAuthSpeciality,
            searchByAuthNumberOrId: true
        }
    )
}
